import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedDomainVerification = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.75 23.75C4.09687 23.75 3.53776 23.5174 3.07266 23.0523C2.60755 22.5872 2.375 22.0281 2.375 21.375V7.125C2.375 6.47187 2.60755 5.91276 3.07266 5.44766C3.53776 4.98255 4.09687 4.75 4.75 4.75H23.75C24.4031 4.75 24.9622 4.98255 25.4273 5.44766C25.8924 5.91276 26.125 6.47187 26.125 7.125V21.375C26.125 22.0281 25.8924 22.5872 25.4273 23.0523C24.9622 23.5174 24.4031 23.75 23.75 23.75H4.75ZM4.75 9.5H23.75V7.125H4.75V9.5ZM13.0031 19.6531L19.7125 12.9437L17.9906 11.2219L13.0031 16.2094L10.5094 13.7156L8.7875 15.4375L13.0031 19.6531Z",
		fill: "url(#paint0_linear_28891_4247)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_28891_4247",
		x1: 2.25003,
		y1: 24,
		x2: 26.25,
		y2: 4.50002,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedDomainVerification;
